import ReactFlagsSelect from 'react-flags-select';
import {Form, Input, Row, Col, Typography} from 'antd';
import countries from '../../../helpers/countries';
import React, {useEffect, useState} from "react";

const {Title} = Typography;

const ProfessionalAddress = ({typeAddress, form}) => {
  const [countrySelectCode, setCountrySelectCode] = useState("BG")

  useEffect(() => {
    handleCountryCode()
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `handleCountryCode` is redefined every render; keying only on `typeAddress` avoids re-deriving the country on every unrelated re-render.
  }, [typeAddress])

  const handleCountryCode = () => {

    const countryCode = countries.find(
      (el) => el.name === form?.getFieldsValue()[typeAddress]?.country,
    )
    if (countryCode?.code) {
      handleCountrySelection(countryCode?.code)
    } else {
      handleCountrySelection("BG")
    }


  }
  const handleCountrySelection = (country) => {
    const countryName = countries.find((c) => c.code === country)
    form?.setFieldValue([typeAddress, 'country'], countryName.name)
    setCountrySelectCode(countryName.code)
  }

  return <Row gutter={24}>
    <Col xs={24}>
      <Title level={5}>{typeAddress === 'address2' ? 'Адрес от лична карта' : 'Адрес'}</Title>
    </Col>
    <Col span={12}>
      <Form.Item
        label="Държава"
        name={[typeAddress, "country"]}
        rules={[{ required: true, message: 'Моля, въведи държава' }]}
      >
        <ReactFlagsSelect
          selectButtonClassName={'custom-country-select'}
          selected={countrySelectCode}
          onSelect={(code) => handleCountrySelection(code)}
          placeholder="Държава"
        />
      </Form.Item>
    </Col>
    <Col span={12}>
      <Form.Item
        label="Квартал"
        name={[typeAddress, "address2"]}
        // rules={[{ required: true, message: 'Please write neighborhood' }]}
      >
        <Input
          placeholder="Квартал"
        />
      </Form.Item>
    </Col>
    <Col span={12}>
      <Form.Item
        label="Адрес"
        name={[typeAddress, "address"]}
        // rules={[{ required: true, message: 'Please write address' }]}
      >
        <Input
          placeholder="Адрес"
        />
      </Form.Item>
    </Col>
    <Col span={12}>
      <Form.Item
        label="Град"
        name={[typeAddress, "city"]}
        // rules={[{ required: true, message: 'Please write city' }]}
      >
        <Input
          placeholder="Град"
        />
      </Form.Item>
    </Col>
    <Col span={12}>
      <Form.Item
        label="Пощенски код"
        name={[typeAddress, "postalCode"]}
        // rules={[{ required: true, message: 'Please write post code' }]}
      >
        <Input
          placeholder="Пощенски код"
        />
      </Form.Item>
    </Col>
  </Row>
}

export default ProfessionalAddress
